import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "login",
  initialState: {
    user: {
      email: "",
      userName: "",
      userType: 0,
    },
  },
  reducers: {
    setEmail: (state, action) => {
      state.user.email = action.payload;
    },
    setUserName: (state, action) => {
      state.user.userName = action.payload;
    },
    setUserType: (state, action) => {
      state.user.userType = action.payload;
    },
    clearAll:(state,action)=>{
      state = action.initialState;
    }
  },
});

export const { setEmail, setUserName, setUserType } = loginSlice.actions;
export default loginSlice.reducer;
